import React, { useEffect, useState } from "react";

import { IRepeat } from "../../../types/repeat";

import { Icons } from '../../../data/Assets';

import { SVGIcon } from '../../wrappers/SVGIcon';

const SideBar = ({
  repeats,
  setRepeats,
  currOption,
  setCurrOption,
}: {
  repeats: IRepeat[];
  setRepeats: React.Dispatch<React.SetStateAction<IRepeat[]>>;
  currOption: number[];
  setCurrOption: React.Dispatch<React.SetStateAction<number[]>>;
}) => {
  const [showNewRepeat, setShowNewRepeat] = useState<boolean>(false);
  const [showRepeat, setShowRepeat] = useState<Set<number>>(new Set());

  const resetStack = () => {
    setCurrOption([repeats.length]);
    setShowRepeat(new Set());
  };

  const isSelect = (checkArr: number[]) => {
    if (checkArr.length !== currOption.length) return "";

    for (let i = 0; i < checkArr.length; i++) {
      if (checkArr[i] !== currOption[i]) return "";
    }
    return "selected";
  };

  useEffect(() => {
    if (currOption[0] === repeats.length) {
      setShowNewRepeat(true);
    } else {
      setShowNewRepeat(false);
    }
  }, [currOption[0]]); //eslint-disable-line

  useEffect(() => {
    setShowNewRepeat(false);
  }, [repeats.length]); //eslint-disable-line

  const handleCreateRepeatNav = () => {
    resetStack();
    setShowNewRepeat(true);
  };

  const handleRepeatSelect = (i: number) => {
    setCurrOption([i]);
  };

  return (
    <div className="side_bar">
      <div className="options">
        <button disabled={showNewRepeat} onClick={handleCreateRepeatNav}>
          <SVGIcon src={Icons.Plus} />
          Repeat
        </button>
      </div>

      <div className="options_tree">
        {(showNewRepeat || repeats.length === 0) && (
          <div
            id="new_section"
            className={`section cont selected`}
            onClick={() => setCurrOption([repeats.length])}
          >
            <SVGIcon src={Icons.PointFill} /> <p>New repeat</p>
          </div>
        )}
        {repeats.map((repeat, i) => (
          <div key={i}>
            <div
              className={`section cont ${isSelect([i])} ${showRepeat.has(i) ? "rotate_svg" : ""
                }`}
              onClick={() => handleRepeatSelect(i)}
            >
              <SVGIcon src={Icons.PointFill} /> <p>{repeat.name}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SideBar;
